import FoodCalculator from "./FoodCalculator";
import utils from "../utils";
import http from '../http';

export default {
  adminCleanFoodItems: function (itemData, spirals) {
    if(itemData.length>0){
      return itemData.map((itemDatum) => {
        return {
          ...itemDatum,
          spirals: itemDatum.spirals.map((spiral) => {

            let rec = spiral.rec_serving_size;
            if(rec!="#N/A" && rec!="#n/a" && rec!="as stated on package"){
              let rs = rec.split(" ");
              let units = {
                'tsp.':'teaspoon',
                'tsp':'teaspoon',
                't.':'teaspoon',
                't':'teaspoon',
                'c.':'cp',
                'c':'cp',
                'T.':'tablespoon',
                'T':'tablespoon',
                'oz.':'floz',
                'oz':'floz',
                'g':'g',
                'g.':'g'
              };

              if(rs[0]=='1/2'){rs[0]='0.5';}
              if(rs[0]=='1/3'){rs[0]='0.333';}
              if(rs[0]=='1/4'){rs[0]='0.25';}
              if(rs[0]=='1/8'){rs[0]='0.167';}
              if(rec.indexOf("slice")>-1 || rec.indexOf("item")>-1 || rec.indexOf("packet")>-1 || rec==''){
                let rm = spiral.rm_serving_size;
                spiral['serving_amount'] = (rs[0]*rm);
                spiral['serving_unit'] = 'g';
                spiral['serving_text'] = 'per '+rs[1];
              }else{
                if(['tsp.','tsp','c.','c','t.','t','T.','T','oz.','oz','g.','g'].includes(rs[1])){ /*keep unit from db*/
                  let cur = rs[1];
                  spiral['serving_amount'] = rs[0];
                  spiral['serving_unit'] = units[cur].replace(".","");
                }else{
                  spiral['serving_amount'] = rs[0]+'??';
                  spiral['serving_unit'] = rs[1].replace(".",""); /*unaccounted for unit*/
                }
              }
            }else{
              spiral['serving_text'] = rec;
            }
            spiral['is_favorite'] = (spiral['is_favorite'] == 'y');

            return spiral;
          }),
        }
      });
    }
    return itemData;
  },
  cleanfooditems: function(itemData) {
    /*Clean up the items*/
    if(itemData.length>0){
      for(let i=0; i<itemData.length; i++){

        let cats = itemData[i].categories;
        let fincats = cats.map(function(c){ return c.name; });
        itemData[i]['cats'] = fincats.join(",");
        if(itemData[i]['cats']==''){ itemData[i]['cats']='N/A';}

        let alls = itemData[i].allergens;
        let finalls = alls.map(function(a){ return a.name; });
        itemData[i]['alls'] = finalls.join(",");
        if(itemData[i]['alls']==''){ itemData[i]['alls']='N/A';}

        /*
				var units_conversion = {
					"tsp":"5",
					"T":"15",
					"oz":"30",
					"c":"240",
					"lb":"480",
					"pint":"480",
					"quart":"960",
					"gallon":"3840",
					"item":"120",
					"1 slice of bread":"28.35",
					"1 slice of cake":"56",
					"1 slice of pie":"56",
					"piece":"30",
					"dash":"0.625",
					"spiral serving":"rm_serving_size"
				};
				var units_volume = [
					"tsp",
					"T",
					"c",
					"pint",
					"quart",
					"gallon"
				];
				var units_weight = [
					"piece",
					"oz",
					"lb",
					"item",
					"dash",
					"spiral serving",
					"1 slice of bread",
					"1 slice of cake",
					"1 slice of pie"
				];*/


        let rec = itemData[i].rec_serving_size;
        if(rec!="#N/A" && rec!="#n/a" && rec!="as stated on package"){
          let rs = rec.split(" ");
          let units = {
            'tsp.':'teaspoon',
            'tsp':'teaspoon',
            't.':'teaspoon',
            't':'teaspoon',
            'c.':'cp',
            'c':'cp',
            'T.':'tablespoon',
            'T':'tablespoon',
            'oz.':'floz',
            'oz':'floz',
            'g':'g',
            'g.':'g'
          };

          if(rs[0]=='1/2'){rs[0]='0.5';}
          if(rs[0]=='1/3'){rs[0]='0.333';}
          if(rs[0]=='1/4'){rs[0]='0.25';}
          if(rs[0]=='1/8'){rs[0]='0.167';}
          if(rec.indexOf("slice")>-1 || rec.indexOf("item")>-1 || rec.indexOf("packet")>-1 || rec==''){
            let rm = itemData[i].rm_serving_size;
            itemData[i]['serving_amount'] = (rs[0]*rm);
            itemData[i]['serving_unit'] = 'g';
            itemData[i]['serving_text'] = 'per '+rs[1];
          }else{
            if(['tsp.','tsp','c.','c','t.','t','T.','T','oz.','oz','g.','g'].includes(rs[1])){ /*keep unit from db*/
              let cur = rs[1];
              itemData[i]['serving_amount'] = rs[0];
              itemData[i]['serving_unit'] = units[cur].replace(".","");
            }else{
              itemData[i]['serving_amount'] = rs[0]+'??';
              itemData[i]['serving_unit'] = rs[1].replace(".",""); /*unaccounted for unit*/
            }
          }
        }else{
          itemData[i]['serving_text'] = rec;
        }
        itemData[i]['is_favorite'] = (itemData[i]['is_favorite']=='y'?true:false);
      }
    }
    return itemData;
  },
  cleanfoodgroupcategories: function(groupData) {
    /*Clean up the food group categories*/
    if(groupData.length>0){
      for(let i=0; i<groupData.length; i++){
        groupData[i]['is_open']=false;
        if(!groupData[i]['items']){
          groupData[i]['items']=[];
          groupData[i]['items'][0]={'name':groupData[i]['name'],'sid':groupData[i]['sid']};
        }
      }
    }
    return groupData;
  },
  adminSearch: async function(query, page = 0, body = {}) {
    if (window.existingSearchAbortController) {
      window.existingSearchAbortController.abort();
      window.existingSearchAbortController = null;
    }

    return await this.real_search(query, page, body, true);
  },
  search: function(query, page = 0, body = {}) {
    if (window.existingSearchAbortController) {
      window.existingSearchAbortController.abort();
      window.existingSearchAbortController = null;
    }

    return this.real_search(query, page, body);
  },
  search2: function(query, page = 0, body = {}) {
    if (window.existingSearchAbortController) {
      window.existingSearchAbortController.abort();
      window.existingSearchAbortController = null;
    }

    return this.real_search2(query, page, body);
  },
  real_search: function(query, page = 0, body = {}, admin = false) {
    const term = query !== '' ? encodeURIComponent(query) : 'all';

    const controller = new AbortController();
    window.existingSearchAbortController = controller;

    return http(admin ? `/admin/api/foodItems/search/${term}` : `/api/fooditems/search/${term}`,{
      method: 'POST',
      body: JSON.stringify({
        'page': page > 0 ? page : '',
        ...body
      }),
      signal: controller.signal,
    })
      .then(async (response) => {
        const body = await response.json();

        if (response.status >= 400) {
          throw new Error(body?.message || response.statusText);
        }

        return body;
      });
  },
  real_search2: async function(query, page = 0, body = {}) {
    // identical to real_search, just can't be cancelled
    const term = query !== '' ? encodeURIComponent(query) : 'all';

    const controller = new AbortController();
    window.existingSearchAbortController2 = controller;

    return http(`/api/fooditems/search/${term}`,{
      method: 'POST',
      body: JSON.stringify({
        'page': page > 0 ? page : '',
        ...body
      }),
      signal: controller.signal,
    })
      .then(response => response.json())
      .then(async function(json) {
        return json;
      });
  },
  process_recipes_for_display: function(recipedata) {
    for (let i = 0; i < recipedata.length; i++) {
      let recipe = recipedata[i];

      /*used for the recipe modal display*/
      let convertdisplayunit = FoodCalculator.displayconvert[recipe.servings_unit];
      let convertval = FoodCalculator.unit_conversion[recipe.servings_unit]; /*grams per unit*/
      let singleservval = parseFloat(recipe.rm_individual_serving_g / convertval).toFixed(1);
      let totalservval = parseFloat(recipe.rm_total_servings_g / convertval).toFixed(1);

      let newdata = {
        id: recipe.id,
        name: recipe.name,
        image_url: recipe.image_url,
        food_factor: utils.round_factor(recipe.rm_factor) + '' + recipe.rm_color,
        food_color: (recipe.rm_color == 'R' ? 'Red' : (recipe.rm_color == 'G' ? 'Green' : 'Yellow')),
        is_favorited: (recipe.is_favorite === 'y'),
        is_active: (recipe.is_active === 'y'),
        single_serving: recipe.rm_individual_serving_g / convertval,
        total_servings: recipe.rm_total_servings_g,
        servings_unit: recipe.servings_unit,
        number_of_servings: recipe.servings,
        allergens: recipe.allergens,
        food_groups: recipe.food_groups,
        directions: recipe.directions,
        spiral_name: recipe.spiral_name,
        display_total: totalservval,
        display_single: singleservval,
        display_unit: convertdisplayunit
      };

      if (recipe.items.length > 0) {
        for (let it = 0; it < recipe.items.length; it++) {
          /*used for the recipe modal display*/
          let convertdisplayunit = FoodCalculator.displayconvert[recipe.items[it].ingredient_quantity_unit];

          recipe.items[it].serving_size = recipe.items[it].ingredient_quantity;
          recipe.items[it].serving_unit = recipe.items[it].ingredient_quantity_unit;
          recipe.items[it].display_unit = convertdisplayunit;
        }
      }

      newdata.ingredients = recipe.items;
      recipedata[i] = newdata;
    }

    return recipedata;
  }
}
